import { AxiosResponse } from "axios";

/**
 * The filename the server put in `Content-Disposition`, or `fallback` when the
 * header is missing or unparseable. The RFC 5987 `filename*=UTF-8''…` form wins
 * over plain `filename=` because it is the only one that can carry Thai.
 */
export const getDispositionFilename = (
  disposition: string | undefined,
  fallback: string,
): string => {
  const utf8Match = disposition?.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition?.match(/filename="?([^";]+)"?/i);
  return utf8Match
    ? decodeURIComponent(utf8Match[1])
    : plainMatch
      ? plainMatch[1]
      : fallback;
};

/**
 * Save a `responseType: "blob"` response to disk under the server's filename.
 * Returns the filename used.
 */
export const saveBlobResponse = (
  response: AxiosResponse,
  fallbackFilename: string,
): string => {
  const filename = getDispositionFilename(
    response.headers["content-disposition"] as string | undefined,
    fallbackFilename,
  );

  const url = window.URL.createObjectURL(response.data as Blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return filename;
};
